module.exports = __webpack_public_path__ + "img/DSC_1093.699f0b4c.jpg";